import { useContext } from 'react'
import { HMapContext } from '../context/HMapContext'

export const useHMapContext = () => useContext(HMapContext)
